export const chargesToolTipText={
    chargesHeadingToolTip:"The data on this page will show which sub accounts these charges are against rather than the account these charges are paid from.",
    platformchargeToolTipText:"Platform charge figures include any Product Administration charges applied to SIPP or Bond product",
    investmentChargeToolTipText:"Investment charges will only apply to certain accounts prior to 2012 (Additional Administration charges)."
}